<template>
	<div class="logout">
		Saliendo del sistema
	</div>
</template>

<script>
	import mixin from '@/mixins'
	import axiosAWN from '@/mixins/axiosAWN.js'
	export default {
		name: 'Logout',
		mixins: [mixin, axiosAWN],
		data() {
			return {
				data: {
				},
			}
		},
		methods: {
			initModuleLocal() {
				this.checkToken()
			},
			checkToken() {
				let token = localStorage.getItem('token')
				if(token == null) {
					this.disconnectResult()
				} else {
					this.disconnect()
				}
			},
			disconnect() {
				this.setHeadersAuthorization(localStorage.getItem('token'))
				localStorage.removeItem('token') 
				let url = this.getApiBackend + 'disconnect'
				this.axiosAWNasyncBlock('Cerrando la sesión...', 'POST', url, 'disconnectResult', null)
				this.disconnectResult()
			},
			disconnectResult(response) {
				this.disconnectResultError()
			},
			disconnectResultError() {
				this.$router.replace('/access')
			}
		},
		mounted () {
			this.initModuleLocal()
		}
	}
</script>
